/** @jsxImportSource @emotion/react */
import React, { useEffect, useState, CSSProperties } from 'react'
import { FormattedMessage } from 'react-intl'
import { Tab, Tabs, Nav, TabContainer, TabContent, Button, OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import { Form, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useStore } from '../../contexts/StoreProvider'
import { observer } from 'mobx-react'
import IQuestionInfo, { IReplyInfo } from '../../models/response/ITestQuestion'
import DetailsPopupHOC from './hoc/DetailsPopupHOC'
import SubCategoryDetailsModal from './DetailsPopup/SubCategoryDetailsModal'
import { ICategoryInfo, IObservationsInfo, ISubCategoryInfo } from '../../models/response/ITestInterpretation'
import BarGraph from './Graphs/BarGraph'
import TwoDimensionalGraph from './Graphs/TwoDimensionalGraph'
import RoutesConstants from '../../shared-components/Routes/routes.constants'
import ScatterGraph from './Graphs/ScatterGraph'
import ScatterGraph3D from './Graphs/ScatterGraph3D';
import { ITestInfo } from '../../models/ITestInfo';
import { formatMessage } from '../../translations/format-message';
import './TestResult.css';
import { css } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

/* Export variable created to manage dynamic value of progressbar. Created by - Pratiksha Sharma */
export interface MyCustomCSS extends CSSProperties {
    '--length': string;
    '--background-color': string;
}

const TestResult = (props: any) => {
    const navigate = useNavigate();
    const { singleTestId } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [multipleTestIds, setMultipleTestIds] = useState<string[]>(searchParams.getAll('testId'));
    const [isComparison, setIsComparison] = useState<boolean>(false);
    const [isScatterPlot, setIsScatterPlot] = useState<boolean>(false);
    const [printEnabled, setPrintEnabled] = useState<boolean>(false);
    const [showDescription, setShowDescription] = useState<boolean>(true);
    const [isDemoTest, setIsDemoTest] = useState<boolean>(false);
    const [hiddenTestId, setHiddenTestId] = useState<Array<number>>([]);
    const { testStore, authStore } = useStore();
    const [data, setData] = useState({
        Details: "",
        ResourceKey: ""
    })
    const observationArray: string[] = [];

    const [id, setid] = useState<Array<number>>([])
    const { getTestAnswers, resultDataList, allResultList, testUserState, getGraphState, getAllQuestions,
        getTestInterpretation, testInterpratationState, getFreeTestInterpretation, allGraphData, allSurveyData, allTestInfo, allTwoDiResult,
        resetTestState, testInterpretationDataList, resetTestInterpretation, /*getDummyTestResult*/ } = testStore;
    const { getEmail, getToken, isAuthenticated } = authStore;


    const getNormalisedDate = (unixTimestamp: string) => {
        if (Number.parseInt(unixTimestamp)) {
            var date = new Date(Number(unixTimestamp) * 1000);
            const formattedDate = date.toLocaleDateString("en-GB", {
                year: "numeric",
                month: "numeric",
                day: "numeric",
            });

            const formattedTime = date.toLocaleTimeString("en-GB", {
                hour12: false, // Use 24-hour format
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
            });

            return `${formattedDate} ${formattedTime}`;
        }
        return "NaN";
    }

    const getColorBasedOnScore = (score: string): string => {
        switch (score) {
            case "1": return "#ec5e4e";
            case "2": return "#fc95b2";
            case "3": return "#f9ca24";
            case "4": return "#f0962a";
            case "5": return "#4330d7";
            default: return "#cfdff8";
        }
    }

    // Single Test
    useEffect(() => {
        const currentTestId = (singleTestId !== undefined) ? parseInt(singleTestId, 10) : undefined;
        if (currentTestId !== undefined && !Number.isNaN(currentTestId)) {
            getTestInterpretation([currentTestId]);
            setIsComparison(false);
            // This is done to reset the state when the user submits the test and the app will automatically navigate to this page.
            resetTestState();
        }
    }, [singleTestId]);

    // Multiple Tests (Comparison)
    // Only do comparison when there are multiple tests selected, otherwise navigate back to dashboard.
    useEffect(() => {
        if (multipleTestIds?.length > 1 && !isComparison) {
            const testIds = multipleTestIds.map(function (testIdStr) { return parseInt(testIdStr); });
            getTestInterpretation(testIds);
            setIsComparison(true);
            if (testIds.length >= 3) {
                setIsScatterPlot(prev => true);
            }
        }
        else if (multipleTestIds?.length == 1) {
            navigate(RoutesConstants.Dashboard);
        }
    }, [multipleTestIds])

    // Free Test
    useEffect(() => {
        if (allTestInfo?.length == 0 || allGraphData?.length == 0 || allSurveyData?.length == 0) {
            if (window.location.pathname == RoutesConstants.DemoTestResult || window.location.pathname == RoutesConstants.DemoTestResult +'/') {
                const score = sessionStorage.getItem("testScore");
                const testType = sessionStorage.getItem("testType");
                const testDate = sessionStorage.getItem("testDate");
                const eventId = sessionStorage.getItem("eventId");
                if (score && testType && testDate) {
                    if (!isAuthenticated && !getToken) {
                        sessionStorage.setItem("moveToPaymentOnClick", "true");
                        
                        if (score && testType && parseInt(testType) && testDate)
                            getFreeTestInterpretation(score, Number(testType), testDate);
                        setIsComparison(true);
                        setIsDemoTest(true);
                        // setIsScatterPlot(prev => true);
                    }
                }
                else {
                    navigate(RoutesConstants.Dashboard);
                }
            }
        }
    }, [allTestInfo, allGraphData, allSurveyData])

    // If unauthorized, redirect to Dashboard.
    // or if authorized, call other APIs.
    useEffect(() => {
        if (testInterpratationState.error == 'Unauthorized') {
            navigate(RoutesConstants.Dashboard);
        }
        else if (testInterpratationState.success) {
            // TODO: Correct isComparison value, currently it is being set completely opposite and implemented the same way.
            // If isComparison = true, then it is a Single Test.
            if (!isComparison && singleTestId) {
                getTestAnswers(parseInt(singleTestId, 10));
            }
        }
    }, [testInterpratationState.error, testInterpratationState.success]);

    useEffect(() => {
        resetTestInterpretation();
        // getDummyTestResult();
    }, []);

    useEffect(() => {
        setTimeout(() => {
            setPrintEnabled(() => true);
        }, 1000);
    }, [isScatterPlot]);

    const handleOpenSubCategoryDetailModal = (subQ: ISubCategoryInfo) => {
        props.createGraphToggleHandler()
        setData({
            "Details": subQ.SubCategory_Details_Key,
            "ResourceKey": subQ.SubCategoryKey
        })
    }

    const handleMoreDetailBtnClick = (index: number) => {
        if (id.includes(index)) {
            setid(id.filter(id => id !== index));
        }
        else {
            setid([...id, index]);
        }
    };

    const handleShowHideTestId = (testId: number) => {
        if (hiddenTestId.includes(testId)) {
            setHiddenTestId(hiddenTestId.filter((id: number) => id != testId));
        }
        else {
            setHiddenTestId([...hiddenTestId, testId]);
        }
    }

    // Printing Function
    const handlePrintClick = () => {
        window.print();
    }
    const [isIOS, setIsIOS] = useState(false);

    useEffect(() => {
        // Detect iOS device
        const userAgent = window.navigator.userAgent;
        const iOS = /iPad|iPhone|iPod/.test(userAgent);
        setIsIOS(iOS);
    }, []);
    const handleCompareTest = (isCompareWithFriends: boolean) => {
        navigate(RoutesConstants.Dashboard, {state: {testId: singleTestId, friendTab: isCompareWithFriends}});
    }

    const getColorBasedOnObservationType = (observationType: string, opacityPercentage: number) => {
        switch (observationType) {
            case "Group_Conflict":
            case "Couple_Big":
            case "Single_Low":
                return `alert-danger`;   // Pink
            case "Group_Balance":
            case "Couple_High":
            case "Single_Balance":
                return `alert-primary`;   // Blue 
            case "Group_Deficiency":
            case "Couple_Low":
            case "Single_High":
                return `alert-warning`; //    // Yellow
            case "Group_Specialized":
            case "Couple_Medium":
                return `alert-success`;     // Green
            default:
                return "alert-info";
        }
    }

    const popover = (test: ITestInfo) => {
        return (
            <Popover id="popover-trigger-focus">
                {/* <Popover.Header as="h3">Arjun Thakur</Popover.Header> */}
                <Popover.Body id="popover-trigger-focus">
                    {test.UserEmail}<br />
                    {getNormalisedDate(test.TestDate)}<br />
                    {allSurveyData.map(ques => {
                        if (ques.Key == "SPORT")
                            return <><b>{`${formatMessage(`${test.TestType}_${ques.Key}`)}: `}</b> {formatMessage(`${test.TestType}_${ques.SelectedOption[0].ReplyKey}`)}<br /></>
                        if (ques.Key == "PF")
                            return <><b>{`${formatMessage(`${test.TestType}_${ques.Key}`)}: `}</b> {formatMessage(`${test.TestType}_${ques.SelectedOption[0].ReplyKey}`)}<br /></>
                    })}
                    <span className='badge bg-primary'>{formatMessage(test.TestType)}</span>
                </Popover.Body>
            </Popover>
        )
    }

    return (
        <>
            {props.showGraphPopup && (
                <SubCategoryDetailsModal modalClosed={props.createGraphToggleHandler} HiddenData={data} />
            )}
            <div className="dashboar-container">
                <div className="dashboard_heading d-print-none">
                    <div className="container">
                        <h1>
                            <FormattedMessage id="test_result" />
                        </h1>
                    </div>
                </div>

                <Tab.Container
                    defaultActiveKey="Graphs"
                    id="uncontrolled-tab-example"
                >
                    <div className="tabWrapper d-print-none">
                        <div className="container">
                            <div className='row align-items-center'>
                                <div className='col-12'>
                                    <Nav variant="underline">
                                        <Nav.Item>
                                            <Nav.Link eventKey="Graphs"><FormattedMessage id="graphs" /></Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="Answers" disabled={isDemoTest ? true : false} ><FormattedMessage id="answers" /></Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </div>

                            </div>
                        </div>
                    </div>
                    <Tab.Content>
                        <Tab.Pane eventKey="Graphs" className={isIOS ? 'ios-print' : ''}>

                            <div className="dashboardTopbar d-print-none stickybar">
                                <div className="container">
                                    <div className="row align-items-center">
                                        <div className="col-8 col-sm-7">
                                            {(isAuthenticated || getToken) &&
                                                <button className="btn btn-secondary mx-2" onClick={() => handlePrintClick()} disabled={!printEnabled}>
                                                    <i className="fa fa-print"></i>&nbsp;&nbsp;<FormattedMessage id="print" />
                                                </button>
                                            }
                                            {(isAuthenticated || getToken) && singleTestId && allTestInfo?.length > 0 && allTestInfo[0].TestId === Number(singleTestId)  
                                                && allTestInfo[0].UserEmail === getEmail && (!isComparison) &&
                                                <>
                                                    <button className="btn btn-warning mx-2 dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <i className="fa fa-users"></i>&nbsp;&nbsp;<FormattedMessage id="compare" />
                                                    </button>
                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                        <li><button className="dropdown-item" onClick={() => handleCompareTest(true)}><FormattedMessage id='compare_friends'/></button></li>
                                                        <li><button className="dropdown-item" onClick={() => handleCompareTest(false)}><FormattedMessage id='compare_tests'/></button></li>
                                                    </ul>

                                                </>
                                            }
                                            <a className="btn btn-link text-dark view_type_btn" data-bs-toggle="collapse" href=".showHideDiv" onClick={() => { setShowDescription(!showDescription) }}>
                                                {!showDescription
                                                    ?
                                                    <>
                                                        <i className="fa fa-eye"></i>&nbsp;&nbsp;<FormattedMessage id="show_description" />
                                                    </>
                                                    :
                                                    <>
                                                        <i className="fa fa-eye-slash"></i>&nbsp;&nbsp;<FormattedMessage id="hide_description" />
                                                    </>
                                                }
                                            </a>
                                        </div>
                                        <div className="col-4 col-sm-5 text-end">
                                            <button className="btn btn-primary" onClick={() => {setIsScatterPlot(!isScatterPlot); setPrintEnabled(false)}}>
                                                {
                                                    (!isScatterPlot)
                                                        ?
                                                        <>
                                                            <i className="fa fa-user"></i>&nbsp;&nbsp;<FormattedMessage id="scatter_plot" />
                                                        </>
                                                        :
                                                        <>
                                                            <i className="fa fa-chart-bar"></i>&nbsp;&nbsp;<FormattedMessage id="bar_graph" />
                                                        </>
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='container'>
                                <p className="show_result_for">
                                    <FormattedMessage id="showing_result_for" />: &nbsp;
                                </p>
                                <div className='row pb-3 g-2 print-four'>                                    
                                    {allTestInfo?.length > 0 && allTestInfo.map((test) => {
                                        return (
                                            <div className='col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 test_user_card'>
                                                <div className='card '>
                                                    <div className='card-body' css={css`
                                                            border-color: ${test.Color} !important;
                                                            border-top: 5px solid ${test.Color} !important;
                                                            font-weight: bold;
                                                        `} >
                                                        <h5 className='m-0'>{test.UserEmail}</h5>
                                                        <small>
                                                        {getNormalisedDate(test.TestDate)}<br />
                                                        {(test.TestType == 'TRAINING' || test.TestType == 'RACING') && allSurveyData.map(ques => {
                                                            if (ques.Key == "SPORT")
                                                                return <><b>{`${formatMessage(`${test.TestType}_${ques.Key}`)}: `}</b> {formatMessage(`${test.TestType}_${ques.SelectedOption[0].ReplyKey}`)}<br /></>
                                                            if (ques.Key == "PF")
                                                                return <><b>{`${formatMessage(`${test.TestType}_${ques.Key}`)}: `}</b> {formatMessage(`${test.TestType}_${ques.SelectedOption[0].ReplyKey}`)}<br /></>
                                                        })}
                                                        </small>
                                                        <div className="d-flex justify-content-between">
                                                            <span className='badge bg-primary'>{formatMessage(test.TestType)}</span>
                                                            {
                                                                isComparison && 
                                                                <button className='badge bg-primary' onClick={() => handleShowHideTestId(test.TestId)}>
                                                                    {!hiddenTestId.includes(test.TestId) 
                                                                        ?
                                                                        <>
                                                                            <i className="fa fa-eye"></i>&nbsp;
                                                                        </>
                                                                        :
                                                                        <>
                                                                            <i className="fa fa-eye-slash"></i>&nbsp;
                                                                        </>
                                                                    }
                                                                </button>
                                                            }
                                                        </div>
                                                    </div>
                                                    {/* <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={popover(test)}>
                                                        <Button variant="link" className='p-0 mx-1' style={{ color: test.Color }}>{test.UserEmail}</Button>
                                                    </OverlayTrigger> */}
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                                <div className='row print-half'>
                                    {
                                        allGraphData.map((dataPoint: ICategoryInfo, index: number) => (
                                            <>
                                                <div className={`chart-wrapper mb-4 ${showDescription ? 'col-12' : 'col-lg-6'}`}>
                                                    <div className='card borderedCard'>
                                                        <div className='card-header bg-light mb-3'>
                                                            <div className='d-flex align-items-center justify-content-between flex-wrap '>
                                                                <h3 className='m-sm-0' key={dataPoint.CategoryKey}><FormattedMessage id={dataPoint.CategoryKey} key={dataPoint.CategoryKey} /></h3>
                                                                <div className='btn-group d-print-none showHideDiv collapse show'>
                                                                    {
                                                                        dataPoint.SubCategoryList.map((subQ, index) => (
                                                                            <>
                                                                                <button onClick={() => handleOpenSubCategoryDetailModal(subQ)} className={`btn d-inline-flex align-items-center btn-${index % 2 === 0 ? "primary" : "secondary"}`}>

                                                                                    <svg version="1.1" className='me-2' width="20" height="20" id="Capa_1" x="0px" y="0px"
                                                                                        viewBox="0 0 512.432 512.432" >
                                                                                        <g>
                                                                                            <g>
                                                                                                <path d="M504.536,468.48l-33.28-33.28c10.24-15.36,15.36-33.28,15.36-51.2c0-56.32-46.08-102.4-102.4-102.4
                                                                                                s-102.4,46.08-102.4,102.4s46.08,102.4,102.4,102.4c17.92,0,35.84-5.12,51.2-15.36l33.28,33.28c5.12,5.12,20.48,15.36,35.84,0
                                                                                                C514.776,494.08,514.776,478.72,504.536,468.48z M384.216,435.2c-28.16,0-51.2-23.04-51.2-51.2s23.04-51.2,51.2-51.2
                                                                                                s51.2,23.04,51.2,51.2S412.376,435.2,384.216,435.2z"/>
                                                                                            </g>
                                                                                        </g>
                                                                                        <g>
                                                                                            <g>
                                                                                                <path d="M384.216,0h-358.4c-15.36,0-25.6,10.24-25.6,25.6v460.8c0,15.36,10.24,25.6,25.6,25.6h273.92
                                                                                                c-40.96-28.16-69.12-74.24-69.12-128c0-84.48,69.12-153.6,153.6-153.6c7.68,0,17.92,0,25.6,2.56V25.6
                                                                                                C409.816,10.24,399.576,0,384.216,0z M205.016,204.8h-128c-15.36,0-25.6-12.8-25.6-25.6c0-15.36,10.24-25.6,25.6-25.6h128
                                                                                                c15.36,0,25.6,10.24,25.6,25.6C230.616,192,220.376,204.8,205.016,204.8z M333.016,102.4h-256c-15.36,0-25.6-12.8-25.6-25.6
                                                                                                c0-15.36,10.24-25.6,25.6-25.6h256c15.36,0,25.6,10.24,25.6,25.6C358.616,89.6,348.376,102.4,333.016,102.4z"/>
                                                                                            </g>
                                                                                        </g>
                                                                                    </svg>
                                                                                    <FormattedMessage id={subQ.SubCategoryKey} />

                                                                                </button>
                                                                            </>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='card-body'>
                                                            <div className='row'>
                                                                <div className={`${!showDescription ? 'col-lg-12' : 'col-lg-6'} col-12`}>
                                                                    {
                                                                        (!isScatterPlot)
                                                                            ?
                                                                            // Not a Scatter Plot i.e. BarGraph
                                                                            <BarGraph dataPoint={dataPoint} allTestInfo={allTestInfo} hiddenTestId={hiddenTestId} />
                                                                            :
                                                                            (dataPoint && dataPoint.SubCategoryList.length === 2)
                                                                                ?
                                                                                // Scatter Plot with 2 SubCategories
                                                                                <ScatterGraph dataPoint={dataPoint} allTestInfo={allTestInfo} hiddenTestId={hiddenTestId}/>
                                                                                :
                                                                                // Scatter Plot with 3 SubCategories
                                                                                <ScatterGraph3D dataPoint={dataPoint} allTestInfo={allTestInfo} hiddenTestId={hiddenTestId}/>
                                                                    }
                                                                </div>
                                                                <div className='col-lg-6 col-12 showHideDiv collapse show'>
                                                                    <div className={`mb-4 ${!showDescription ? 'd-print-none' : ' '}`} >
                                                                        <p>
                                                                            <FormattedMessage id={dataPoint.DetailsVisible_Key} />
                                                                        </p>
                                                                        {
                                                                            <div className='d-print-none'>

                                                                                <button
                                                                                    key={index} // Ensure each button has a unique key
                                                                                    className='btn btn-link p-0'
                                                                                    onClick={() => handleMoreDetailBtnClick(index)}
                                                                                >
                                                                                    {id.includes(index) ? (
                                                                                        <FormattedMessage id='less_details' />
                                                                                    ) : (
                                                                                        <FormattedMessage id='more_details' />
                                                                                    )}
                                                                                </button>
                                                                            </div>
                                                                        }

                                                                        {
                                                                            id.includes(index) 
                                                                                ? 
                                                                                <>
                                                                                    <hr style={{ backgroundColor: "black" }} className='d-print-none'/>
                                                                                    <div className='showHideDiv collapse show d-print-none'> 
                                                                                        <p style={{"whiteSpace": "pre-line"}}>
                                                                                            <FormattedMessage id={dataPoint.DetailsHidden_Key} />
                                                                                        </p>
                                                                                    </div>
                                                                                </> 
                                                                                : 
                                                                                null
                                                                        }

                                                                    </div>
                                                                    {
                                                                        dataPoint.Observations.map((observation: IObservationsInfo, observationIndex: number) => {
                                                                            if (observationArray.indexOf(`Observation_${formatMessage(observation.Observation_Key)}`) == -1) {
                                                                                observationArray.push(`Observation_${formatMessage(observation.Observation_Key)}`);
                                                                                return (
                                                                                    <>
                                                                                        <h5 className={`{ fw-normal alert  ${getColorBasedOnObservationType(observation.Type, 40)}`}>
                                                                                            <FormattedMessage id={observation.Observation_Key} />
                                                                                        </h5>
                                                                                    </>)
                                                                            }
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ))
                                    }
                                
                                    {allTwoDiResult && allTwoDiResult.length > 0 &&
                                        <>
                                            
                                                <div className={`mb-4 ${!showDescription ? 'col-lg-6' : 'col-lg-12'} col-12 foursideGraph`}>
                                                    <div className='card borderedCard'>
                                                        <div className='card-header'>
                                                            <div className='d-flex align-items-center justify-content-between'>
                                                                <h3 className='m-0'><FormattedMessage id={"fourSideMessage"} /></h3>
                                                            </div>
                                                        </div>
                                                        <div className='card-body'>
                                                            <div className='row'>
                                                                <div className={`${!showDescription ? 'col-lg-12' : 'col-lg-6'} col-12`}>
                                                                    <TwoDimensionalGraph dataPoint={allTwoDiResult} allTestInfo={allTestInfo} hiddenTestId={hiddenTestId} />
                                                                </div>
                                                                <div className='col-lg-6 col-12 showHideDiv collapse show'>
                                                                    <div className='mb-4'>
                                                                        <p style={{"whiteSpace": "pre-line"}}>
                                                                            <FormattedMessage id='FourSide_QN' />
                                                                        </p>
                                                                        {
                                                                            <div className='d-print-none'>

                                                                                <button
                                                                                    key={100} // Ensure each button has a unique key
                                                                                    className='btn btn-link p-0'
                                                                                    onClick={() => handleMoreDetailBtnClick(100)}
                                                                                >
                                                                                    {id.includes(100) ? (
                                                                                        <FormattedMessage id='less_details' />
                                                                                    ) : (
                                                                                        <FormattedMessage id='more_details' />
                                                                                    )}
                                                                                </button>
                                                                            </div>
                                                                        }

                                                                        {
                                                                            id.includes(100) 
                                                                                ? 
                                                                                <>
                                                                                    <hr style={{ backgroundColor: "black" }} className='d-print-none'/>
                                                                                    <div className='showHideDiv collapse show d-print-none'> 
                                                                                        <p style={{"whiteSpace": "pre-line"}}>
                                                                                            <FormattedMessage id="FourSide_HD" />
                                                                                        </p>
                                                                                    </div>
                                                                                </> 
                                                                                : 
                                                                                null
                                                                        }

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-12'></div>
                                            
                                        </>
                                    }

                                    {/* In case of Free, don't show the Long Term and Short Term */}
                                    { (allGraphData && allGraphData.length > 3) && allSurveyData && allSurveyData.map((surveyData) => {
                                        if (surveyData.Key != 'SPORT' && surveyData.Key != 'PF')
                                            return (
                                                <>
                                                    
                                                        <div className='col-12 col-lg-6 mt-4'>
                                                            <div className='card borderedCard d-print-flex'>
                                                                <div className='card-header'>
                                                                    <h3><FormattedMessage id={surveyData.Key} /></h3>
                                                                </div>
                                                                <div className='card-body'>
                                                                    <div className='progressbar_wrap'>
                                                                        {allTestInfo.filter(test => !hiddenTestId.includes(test.TestId)).map((test: ITestInfo, index: number) => {
                                                                            const selected = surveyData.SelectedOption.find(x => x.TestId == test.TestId);
                                                                            const totalMarks = surveyData.OptionsList.length;
                                                                            const widthOfEachMark = 100 / totalMarks;
                                                                            const selectedMark = (selected) ? surveyData.OptionsList.indexOf(selected.ReplyKey) + 1 : 0;
                                                                            return (
                                                                                <>
                                                                                    <div className={`progress ${(index !== allTestInfo.length - 1) && "mb-2"}`}>                                                                      
                                                                                        <div className="progress-bar" style={{ '--length': `${widthOfEachMark * selectedMark}%`, '--background-color': test.Color } as MyCustomCSS}></div>
                                                                                    </div>
                                                                                </>
                                                                            )
                                                                        })}
                                                                        <ul className="list-group term-list">
                                                                            {surveyData.OptionsList.map((option: string) => {
                                                                                const totalMarks = surveyData.OptionsList.length;
                                                                                const widthOfEachMark = 100 / totalMarks;

                                                                                return (
                                                                                    <li className="list-group-item" style={{ '--length': `${widthOfEachMark}%` } as MyCustomCSS}>
                                                                                        <div className="timeq-persons small" style={{ margin: 0 }}>
                                                                                            <FormattedMessage id={`LIFE_${option}`} />
                                                                                            {allTestInfo.filter(test => !hiddenTestId.includes(test.TestId)).map((test: ITestInfo, index: number) => {
                                                                                                const selected = surveyData.SelectedOption.find(x => x.TestId == test.TestId);
                                                                                                return (
                                                                                                    <>
                                                                                                        {
                                                                                                            selected?.ReplyKey == option &&
                                                                                                            <OverlayTrigger
                                                                                                                key='top'
                                                                                                                placement='top' 
                                                                                                                overlay={
                                                                                                                    <Tooltip className='' id='tooltip-top'>{`${test.FirstName ?? ""} ${test.LastName ?? ""} \n ${test.UserEmail}`}</Tooltip>
                                                                                                                }
                                                                                                            >
                                                                                                                <FontAwesomeIcon color={test.Color} icon={faUser} className='user_image ms-2' size="lg" style={{ zIndex: '1'}}
                                                                                                                />
                                                                                                            </OverlayTrigger>
                                                                                                        }
                                                                                                    </>
                                                                                                )
                                                                                            })}
                                                                                        </div>
                                                                                    </li>
                                                                                )
                                                                            })}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        

                                                </>
                                            )
                                    })}
                                </div>
                                {
                                    allGraphData && allGraphData.length === 3 &&
                                    <div className='d-block m-auto fs-5 text-center'>
                                        <button type="button" className='btn btn-danger mt-4 btn-lg d-block m-auto my-3 fs-3' onClick={() =>
                                            (!isAuthenticated && !getToken) 
                                            ?
                                                navigate(RoutesConstants.Dashboard)
                                            :
                                                navigate(RoutesConstants.TestPayment, {state: {testId: singleTestId}})
                                        }><FormattedMessage id="to_know_all" /></button>
                                        <p>
                                            <FormattedMessage id="to_know_all_sub_message"/>
                                        </p>
                                    </div>
                                }

                                {allGraphData && allGraphData.length > 0 &&
                                <div className='d-print-none'>
                                    <div className="row mt-4 ">
                                        <div className="col-sm-12">
                                            <h1>Summary</h1>
                                        </div>

                                        {
                                            allGraphData.map((dataPoint: ICategoryInfo, index: number) => (
                                                <>
                                                    <div className="col-sm-12">
                                                        <div className="card borderedCard mb-4 card-body">
                                                            <strong className="text-dark"><FormattedMessage id={dataPoint.CategoryKey} /></strong>
                                                            <div className="txt">
                                                                {
                                                                    dataPoint.Observations.map((observation, observationIndex) => {
                                                                        if (observationArray.indexOf(`Summary_${formatMessage(observation.Observation_Key)}`) == -1) {
                                                                            observationArray.push(`Summary_${formatMessage(observation.Observation_Key)}`);
                                                                            const HRElement = (observationIndex != 0) && <hr />
                                                                            return (
                                                                                <>
                                                                                    {HRElement}
                                                                                    <h5 className={`{ fw-normal alert  ${getColorBasedOnObservationType(observation.Type, 40)}`}>
                                                                                        <FormattedMessage id={observation.Observation_Key} />
                                                                                    </h5>
                                                                                </>
                                                                            )
                                                                        }
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ))
                                        }
                                    </div>
                                </div>
                                }

                            </div>

                        </Tab.Pane>

                        <Tab.Pane eventKey="Answers">
                            <div className='container'>
                                {!isComparison ? (
                                    <div className='row'>
                                        {
                                            allResultList.map((result: IQuestionInfo, index) => {
                                                if (result.SubQuestions && result.SubQuestions.length > 0)
                                                    return <>
                                                        <div className='col-12 mb-4'>
                                                            <div className='card borderedCard'>
                                                                <div className='card-header'>
                                                                    <h4><FormattedMessage id={`${resultDataList.TestType}_${result.Key}`} /></h4>
                                                                </div>
                                                                <div className='card-body'>
                                                                    {
                                                                        result.SubQuestions.length > 0 &&
                                                                        result.SubQuestions.map((sub) => (<>
                                                                            <p>
                                                                                <FormattedMessage id={`${resultDataList.TestType}_${sub.Key}`} />
                                                                                &nbsp; : &nbsp;
                                                                                <span className='badge p-2' style={{ background: getColorBasedOnScore(String(sub.Score)), borderColor: getColorBasedOnScore(String(sub.Score)) }}><FormattedMessage id={`${resultDataList.TestType}_SCORE_${sub.Score}`} /></span>
                                                                            </p>
                                                                        </>))
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                            })
                                        }
                                    </div>
                                ) : (
                                    <div className="text-center">
                                        <svg clip-rule="evenodd" fill-rule="evenodd" height="120" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 64 64" width="120" xmlns="http://www.w3.org/2000/svg"><g id="Exp-2.-F"><path d="m27 9.677c0-.265.105-.519.293-.707.187-.187.442-.293.707-.293h22.554l11.446 12.693v15.953s.036 13.177-3.707 19.468c-.182.289-.5.464-.842.464-3.827.003-26.548.003-32.899.003-.351 0-.676-.185-.857-.485-.181-.301-.19-.675-.025-.985 3.103-6.737 3.33-18.465 3.33-18.465z" fill="#cadcf0" /><path d="m62 37.323s.036 13.177-3.707 19.468c-.182.289-.5.464-.842.464-3.827.003-26.548.003-32.899.003-.351 0-.676-.185-.857-.485-.181-.301-.19-.675-.025-.985l.039-.086c12.314.579 30.196-1.578 32.551-2.5 2.516-.985 5.69-10.437 5.739-15.755z" fill="#a4bbdb" /><path d="m62 21.37c-3.036-1.199-6.25-1.233-9.549-.724-.306.049-.617-.049-.842-.262-.225-.214-.337-.52-.304-.828.362-3.694-.003-7.308-.751-10.879 4.838 3.592 8.658 7.819 11.446 12.693z" fill="#347bfa" /><path d="m27 12.068c2.674.333 5.262 1.525 7.314 3.577 4.103 4.103 4.769 10.349 1.999 15.148l1.647 5.223c.081.257.013.537-.177.727-.047.046-.095.094-.14.14-.179.178-.442.242-.682.166l-5.249-1.655c-1.474.851-3.085 1.378-4.728 1.58.012-.331.016-.513.016-.513z" fill="#a4bbdb" /><path d="m30.447 34.168c-4.588 2.649-10.56 2.012-14.483-1.911-4.683-4.683-4.683-12.287 0-16.97 4.683-4.684 12.287-4.684 16.971 0 3.922 3.922 4.559 9.894 1.911 14.482l1.574 4.994c.078.245.012.513-.169.694-.045.045-.09.09-.134.134-.171.171-.422.232-.652.16z" fill="#e9f3fc" /><g fill="#347bfa"><path d="m22.333 20.182c-.022-.954.335-1.649.888-2.057.868-.64 2.164-.613 2.868.18.303.341.478.823.483 1.433.012 1.462-.675 2.317-1.346 3.203-.904 1.193-1.807 2.419-1.919 4.466-.03.551.393 1.023.944 1.053s1.023-.393 1.053-.944c.085-1.555.829-2.461 1.516-3.367.92-1.213 1.768-2.423 1.752-4.427-.01-1.178-.403-2.087-.987-2.745-1.365-1.537-3.87-1.702-5.551-.462-1.008.744-1.741 1.976-1.7 3.714.013.552.471.989 1.023.976s.989-.471.976-1.023z" /><circle cx="24.212" cy="30.944" r="1.23" /><path d="m12.217 7.364 4 5.032c.344.432.973.504 1.405.161s.504-.973.161-1.405l-4-5.032c-.344-.432-.973-.504-1.405-.161-.432.344-.504.973-.161 1.405z" /><path d="m1.502 9.867 10.452 6c.478.275 1.09.11 1.365-.369s.109-1.09-.37-1.365l-10.451-6c-.479-.275-1.09-.11-1.365.369s-.11 1.09.369 1.365z" /><path d="m3 21h7c.552 0 1-.448 1-1s-.448-1-1-1h-7c-.552 0-1 .448-1 1s.448 1 1 1z" /></g></g></svg>
                                        <p className="noData text-muted text-center h4 mb-0">
                                            <FormattedMessage id="No Answers" />
                                        </p>
                                        <p className="mb-3">
                                            <FormattedMessage id="Answers are not available for comparison" />
                                        </p>
                                    </div>
                                )}
                            </div>

                        </Tab.Pane>

                    </Tab.Content>
                </Tab.Container>
                {
                    testInterpretationDataList.IsSogileBurnout == true && (

                        <div className='container'>
                            <div className="alert alert-danger">
                                <h2><i className="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>   <FormattedMessage id="result_page_warning" />  </h2></div>
                        </div>
                    )
                }

            </div>
        </>
    )
}

export default DetailsPopupHOC(observer(TestResult));
